class MenuItem {
  HAS_CUSTOM_SUBMENU: string;

  HAS_CHILDREN: string;

  LINK_PARENT_ACTIVE: string;

  MEGA_MENU_ACTIVE: string;

  link: HTMLAnchorElement;

  ariaExpanded: string;

  submenu: HTMLElement;

  submenuInner: HTMLElement;

  back: HTMLElement;

  open: boolean;

  reference: EventListener | null;

  constructor(private menuItem: HTMLLIElement) {
    // Class variables
    this.HAS_CUSTOM_SUBMENU = 'menu__item--has-custom-submenu';
    this.HAS_CHILDREN = 'menu__item--has-children';
    this.LINK_PARENT_ACTIVE = 'menu__item--active';
    this.MEGA_MENU_ACTIVE = 'mega-menu--active';

    // Element variables
    this.link = this.menuItem?.querySelector(':scope > .menu__link');
    this.ariaExpanded = this.link?.dataset.ariaExpanded;
    this.submenu = document.querySelector(`nav.mega-menu[data-submenu-id="${this.menuItem.id}"]`);
    this.submenuInner = this.submenu?.querySelector('.mega-menu__inner');
    this.back = this.submenu?.querySelector('.header__back');

    // Set HAS_CHILDREN class
    if (this.menuItem.classList.contains(this.HAS_CUSTOM_SUBMENU)) {
      this.menuItem.classList.add(this.HAS_CHILDREN);

      // Add eventListener to menuItem
      this.menuItem.addEventListener('click', (e) => this.toggleSubmenu(e));
    }

    // Is the submenu open?
    this.open = false;

    // Store reference of handleOutsideClick function
    this.reference = null;
  }

  toggleSubmenu(e: Event) {
    e.preventDefault();

    if (this.open) {
      this.closeSubmenu(e);
    } else {
      this.openSubmenu();
    }
  }

  closeSubmenu(e: Event) {
    if (!this.submenuInner?.contains(e.target as Node)) {
      this.menuItem.classList.remove(this.LINK_PARENT_ACTIVE);
      this.submenu?.classList.remove(this.MEGA_MENU_ACTIVE);
      this.link?.setAttribute('aria-expanded', 'false');

      this.open = false;

      document.removeEventListener('click', this.reference, true);
    }
  }

  openSubmenu() {
    this.menuItem.classList.add(this.LINK_PARENT_ACTIVE);
    this.submenu?.classList.add(this.MEGA_MENU_ACTIVE);
    this.link?.setAttribute('aria-expanded', 'true');
    this.back?.setAttribute('aria-expanded', 'true');

    this.open = true;

    document.addEventListener('click', this.reference = (e) => this.closeSubmenu(e), true);
  }
}

export default MenuItem;
